/**
 * If a string is null, empty, or whitespace
 * @param input string to test
 */
export function isNullOrWhitespace(input: string): boolean {
	if (typeof input === 'undefined' || input == null) return true;

	if (typeof input !== 'string') {
		console.warn('Calling isNullOrWhitespace and type is not string', input);
		return false;
	}

	return input.replace(/\s/g, '').length < 1;
}
